import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "design",
  listKey: "designs",
  itemKey: "design",
  getAll: types.GET_ALL_DESIGNS,
  getAllResponse: types.GET_ALL_DESIGNS_RESPONSE,
  getByIdResponse: types.GET_DESIGN_BY_ID_RESPONSE,
});
